import * as React from "react";
import { action } from "mobx";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ActivityExperience } from "../../../models/profile";
import { Grid, Row, Col } from "react-flexbox-grid";
import ResumeNavBtns from "../resumeNavBtns";
import { LookupType, EmptyId } from "../../../models/enums";
import { LookupValue } from "../../../models/lookup";
import { IResumeLocalization, IAddActivityLocalization } from "../../../models/localization";
import { FormControl } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Select from "material-ui/Select";
import { MMYYRangePicker, MMYYPickValue } from "../../widgets/mmyyPicker";
import TextField from "material-ui/TextField";
import ReferenceEditor, { RefField } from "../referenceEditor";
import DescriptionEditor from "../descriptionEditor";
import * as s from "./lifeExperience.css";

@observer
class ActivityTypePicker extends React.Component<{ store: SeekerStore, exp: ActivityExperience }, {}> {
    constructor(props: any) {
        super(props);
    }
    getMenuItems(): JSX.Element[] {
        const items: JSX.Element[] = [];
        items.push(<MenuItem key="no-sel" value={EmptyId}>{this.props.store.localization.fields.select}</MenuItem>);
        this.props.store.localization.getLookup(LookupType.LifeEventTimeseries).map((lv: LookupValue, i: number): void => {
            items.push(<MenuItem key={i} value={lv.idHash}>{lv.value}</MenuItem>);
        });
        return items;
    }
    @action onSetExpType = (e: any): void => {
        this.props.exp.typeId = e.target.value;
        this.props.exp.actType = e.target.value === EmptyId ? 0 : 1;
    }
    render(): JSX.Element {
        const activityLocal: IAddActivityLocalization = this.props.store.localization.fields.addActivity;
        return <Row>
            <Col xs={12}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="typeId">{activityLocal.title}</InputLabel>
                    <Select value={this.props.exp.typeId} onChange={this.onSetExpType} inputProps={{ name: "typeId", id: "typeId" }}>
                        {this.getMenuItems()}
                    </Select>
                </FormControl>
            </Col>
        </Row>
    }
}

@inject("store") @observer
export default class ActivityExperienceEditor extends React.Component<{ store: SeekerStore, exp: ActivityExperience, fromResume: boolean }, {}> {
    constructor(props: any) {
        super(props);
    }
    @action onChangeMMYY = (val: number, fmt: MMYYPickValue): void => {
        switch (fmt) {
            case MMYYPickValue.FromMon:
                this.props.exp.fromMon = val;
                break;
            case MMYYPickValue.FromYear:
                this.props.exp.fromYear = val;
                break;
            case MMYYPickValue.ToMon:
                this.props.exp.toMon = val;
                break;
            case MMYYPickValue.ToYear:
                this.props.exp.toYear = val;
                break;
            case MMYYPickValue.Current:
                this.props.exp.active = val === 1;
                break;
        }
    }
    @action setProperty = (e: any): void => {
        this.props.exp[e.target.name] = e.target.value;
    }
    @action onChangeReference = (val: string, fmt: RefField): void => {
        switch (fmt) {
            case RefField.Name:
                this.props.exp.refName = val;
                break;
            case RefField.Title:
                this.props.exp.refTitle = val;
                break;
            case RefField.Phone:
                this.props.exp.refPhone = val;
                break;
            case RefField.Contact:
                this.props.exp.refContact = val;
                break;
        }
    }
    render(): JSX.Element {
        const actLocal: IAddActivityLocalization = this.props.store.localization.fields.addActivity;
        const editActivity: ActivityExperience = this.props.store.profileStore.editActivity;
        return (
            <div>
            <Row>
              <Col xs={12} sm={6} xl={4} className={s.col}>
                        <TextField label={actLocal.name} value={this.props.exp.org} onChange={this.setProperty} name="org" fullWidth />
              </Col>
              <Col xs={12} sm={6} xlOffset={1} xl={4} className={s.col}>
                        <TextField label={actLocal.role} value={this.props.exp.role} onChange={this.setProperty} name="role" fullWidth />
              </Col>
              </Row>
              <Row>
              <Col xs={12} sm={6} xl={4} className={s.col}>
                        <ActivityTypePicker store={this.props.store} exp={editActivity} />
                    </Col>
              </Row>  
                <Row className={s.row}>
                    <Col xs={12} sm={12} md={6} lg={6} xl={4}>
                        <MMYYRangePicker store={this.props.store} title={actLocal.participated} fromLabel={actLocal.from} toLabel={actLocal.to} fwd={false}
                            currentLabel={actLocal.active} current={this.props.exp.active} fromMon={this.props.exp.fromMon} fromYr={this.props.exp.fromYear} toMon={this.props.exp.toMon} toYr={this.props.exp.toYear}
                            onChange={this.onChangeMMYY} />
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xlOffset={1} xl={4}>
                        <ReferenceEditor store={this.props.store} reference={this.props.exp} onChange={this.onChangeReference} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <DescriptionEditor store={this.props.store} descriptor={this.props.exp} />
                    </Col>
                </Row>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/lifeExperienceEditor/index.tsx